<template>
  <div class="enterExamDialog">
    <div style="padding: 20px 0;font-weight: 700; font-size: 24px;">{{titleExam}}</div>

    <div class="banner-box">
      <div class="banner-box-left">
        <div class="title-box">
          <span class="title-weight">考试时间：</span>
          <span>{{ examInfo.beginTime }} 至 {{examInfo.endTime}}</span>
        </div>
        <div class="title-box">
          <span class="title-weight">当前IP：</span>
          <span>{{examInfo.currentIp}}</span>
          <div class="ip-style" v-if="examInfo.isIp">
            <span style="color: #8fd57c;font-size: 14px;">IP验证已通过</span>
          </div>
          <div style="margin-left: 10px;color: red;" v-else>
            <span style="color: red;font-size: 14px;">IP验证未通过</span>
          </div>
        </div>

        <div class="title-box">
          <span class="title-weight">可切屏次数：</span>
          <span>{{examInfo.screenCount}}</span>
        </div>
        <div class="title-box">
          <span class="title-weight">当前时间：</span>
          <span style="color: red">{{ date }} {{time}}</span>
        </div>
        <div v-if="examInfo.pwd && examStatusStart == true && examStatusEnd==true" style="margin-top: 20px;" class="title-box">
          <span style="flex-shrink: 0;" class="title-weight"><b style="color: red;">*</b>考试密码：</span>
          <el-input placeholder="请输入考试密码后进入考试" v-model="examPwd" clearable></el-input>
        </div>
      </div>

      <div class="banner-box-right">
        <div class="title-box">
          <div class="title-weight">备注：</div>
          <ul class="ul-style">
            <li class="li-style">失去焦点、窗口最小化、打开新页面、点击主菜单、点击桌面、点击任务栏等动作自动视为切屏作弊，达到切屏次数后将自动交卷。</li>
            <li class="li-style">正式考试仅有一次答题机会；提交答卷后将不可再次进行考试</li>
          </ul>
        </div>
      </div>
    </div>

    <div>
      <div v-if="!examInfo.isIp" style="padding-top: 20px">
        <el-button type="info" disabled>您的IP地址未通过，不能参加考试</el-button>
      </div>
      <div v-else-if="!examInfo.isExamPeo" style="padding-top: 20px">
        <el-button type="info" disabled>您不是本次考试人员，不能参加考试</el-button>
      </div>
      <div v-else-if="examInfo.isSubmit" style="padding-top: 20px">
        <el-button type="info" disabled>您已考过，不能重复考试</el-button>
      </div>
      <div v-else style="padding-top: 20px">
        <el-button v-if="examStatusStart == false && examStatusEnd==true" type="info" disabled>考试未开始</el-button>
        <el-button
          v-if="examStatusStart == true && examStatusEnd==true"
          type="danger"
          @click="EnterPaper"
        >进入考试</el-button>
        <el-button v-if="examStatusEnd == false" type="info" disabled>考试已结束</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  //SelectPointExam,
  EnterPaper,

} from '@/api/exam/paper';
import * as Exam from '@/api/exam/exam';
import vsmallheader from '@/views/smallHeader/index';
import {GetCertifyUrl} from "@/api/public";

export default {
  props: ['titleExam'],
  components: {
    vsmallheader,
  },
  data() {
    return {
      paperId: localStorage.getItem('paperId'),
      Ids: localStorage.getItem('Id'),
      enterPaperId: 0, //进入考试时的id
      examId: 0, //考试id
      userId: this.$store.state.User.ids, //用户id
      examStatusStart: false,
      examStatusEnd: true,
      date: '',
      time: '',
      week: null,
      ip: '',
      examInfo: {},
      nowTime: '', //现在的时间
      examPwd: '',
    };
  },
  methods: {
   
    //进入考试页面
    EnterPaper() {
      if(this.examInfo.pwd){
        if(!this.examPwd){
          this.$message.warning('请填写考试密码后进入考试');
          return false
        }else if(this.examPwd != atob(this.examInfo.pwd)){
          this.$message.warning('密码错误，请输入正确的考试密码！');
          return false
        }
      }
	    GetCertifyUrl({userId:JSON.parse(this.$store.state.User.infos).id}).then((res) => {
	        window.location.href = res.result;
	    })


      // let para = {
      //   examId: parseInt(this.Ids),
      //   createId: this.userId,
      // };
	  //
      // EnterPaper(para).then((res) => {
      //   this.enterPaperId = res.result;
      //   if (res.code == 200) {
      //     this.$message({
      //       message: '请开始作答',
      //       type: 'success',
      //     });
      //     this.$router.push({
      //       path: '/Details',
      //       query: {
      //         examPaperId: res.result,
      //       },
      //     });
      //   } else {
      //     this.$message.error('服务器故障，请稍后重试');
      //   }
      // });
    },
    //获取当前年月日
    updateTime() {
      this.week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      let cd = new Date();
      this.nowTime = cd;
      this.time =
        this.zeroPadding(cd.getHours(), 2) +
        ':' +
        this.zeroPadding(cd.getMinutes(), 2) +
        ':' +
        this.zeroPadding(cd.getSeconds(), 2);
      this.date =
        this.zeroPadding(cd.getFullYear(), 4) +
        '-' +
        this.zeroPadding(cd.getMonth() + 1, 2) +
        '-' +
        this.zeroPadding(cd.getDate(), 2) +
        ' ' +
        this.week[cd.getDay()];
      let endTime = new Date(this.examInfo.endTime);
      if (cd > endTime) {
        this.examStatusEnd = false;
      }
      let beginTime = new Date(this.examInfo.beginTime);
      if (cd < beginTime) {
        this.examStatusStart = false;
      }else{
        this.examStatusStart = true;
      }
    },
    zeroPadding(num, digit) {
      var zero = '';
      for (var i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    },
    //获取IP
    getUserIP(onNewIP) {
      let MyPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;

      let pc = new MyPeerConnection({
        iceServers: [],
      });

      let noop = () => {};

      let localIPs = {};

      let ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

      let iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip);

        localIPs[ip] = true;
      };

      pc.createDataChannel('');

      pc.createOffer()
        .then((sdp) => {
          sdp.sdp.split('\n').forEach(function (line) {
            if (line.indexOf('candidate') < 0) return;

            line.match(ipRegex).forEach(iterateIP);
          });

          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch((reason) => {});

      pc.onicecandidate = (ice) => {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        )
          return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },
    //获取进入考试信息
    getExamProcessInfo() {
      let para = {
        userId: this.userId,
        examId: parseInt(this.Ids),
      };
      Exam.getExamProcessInfo(para).then((res) => {
        console.log('考试信息',res.result)
        this.examInfo = res.result;
      });
    },
  },
  created() {
    this.getExamProcessInfo();
  },
  mounted() {
    setInterval(this.updateTime, 1000);
    this.getUserIP((ip) => {
      this.ip = ip;
    });
  },
  watch: {
    nowTime(newValue) {
      let beginTime = new Date(this.examInfo.beginTime);
      if (newValue >= beginTime) {
        this.examStatusStart = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.enterExamDialog {
  width: 100%;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .banner-box {
    display: flex;
    width: 100%;
    padding: 30px 0;
    border-top: 1px solid #80808029;
    border-bottom: 1px solid #80808029;
    .banner-box-left {
      width: 50%;
      line-height: 42px;
      .title-box {
        display: flex;
        align-items: center;
      }
      .title-weight {
        text-align: right;
        font-weight: 700;
        width: 150px;
      }
    }
    .banner-box-right {
      width: 50%;
      .title-weight {
        font-weight: 700;
        height: 42px;
        line-height: 42px;
      }
      .ul-style {
        line-height: 32px;
        margin-top: 10px;
        font-size: 16px;
        margin-left: 20px;
        .li-style {
          list-style-type: disc;
          margin-top: 10px;
        }
      }
    }
  }
}
.ip-style {
  margin-left: 10px;
  color: #8fd57c;
  border: 1px solid #8fd57c;
  border-radius: 5px;
  height: 25px;
  line-height: 25px;
  padding: 0 30px;
}
</style>